export const numberFormatMixins = {
	methods: {
		formatNumberField(field) {
			const priceFormat = parseFloat(this[field]).toFixed(2);

			if (field < 0) {
				this[field] = '0.00';
			} else {
				this[field] = isNaN(priceFormat) ? parseFloat('0').toFixed(2) : priceFormat;
			}
		},
		allowOnlyNumbers(e) {
            const invalidChars = ["-", "+", "e", "E"];
            if (invalidChars.includes(e.key)) {
                e.preventDefault();
            }
        },
		formatNumberValue(value) {
			const priceFormat = parseFloat(value).toFixed(2);

			if (value < 0) {
				return '0.00';
			} else {
				return isNaN(priceFormat) ? parseFloat('0').toFixed(2) : priceFormat;
			}
		},
		formatIntlNumberFormatValue(value) {
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(value);
		},
		
	}
}